<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getDepartmentAllList,
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        waringTypeOptions: [],
        orgIdOptions: [],
        form: [
          { // 司机
            label: '司机',
            value: 'userName',
            type: 'input',
            placeholder: '请输入司机',
          },
          { // 预警类型
            label: '预警类型',
            value: 'waringType',
            type: 'select',
            placeholder: '请选择预警类型',
          },
          { // 预警时间
            label: '预警时间',
            value: 'insurance',
            type: 'date',
            placeholder: '请输入预警时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 处理状态
            label: '处理状态',
            value: 'state',
            type: 'select',
            placeholder: '请选择处理状态',
            options: [
              {
                label: '未处理',
                value: 1,
              },
              {
                label: '已处理',
                value: 2,
              },
            ],
          },
          { // 处理时间
            label: '处理时间',
            value: 'DealDate',
            type: 'date',
            placeholder: '请输入处理时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 处理人
            label: '处理人',
            value: 'dealUserName',
            type: 'input',
            placeholder: '请输入处理人',
          },
          { // 归属部门
            label: '归属部门',
            value: 'orgId',
            type: 'select',
            placeholder: '请选择归属部门',
          },
          { // 归属员工
            label: '归属员工',
            value: 'relUserName',
            type: 'input',
            placeholder: '请输入归属员工',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 预警时间
      if (searchBoxData.insurance && searchBoxData.insurance.length > 0) {
        searchBoxData.insuranceStartDate = this.formatDate(searchBoxData.insurance[0]);
        searchBoxData.insuranceEndDate = this.formatDate(searchBoxData.insurance[1]);
        delete searchBoxData.insurance;
      }
      // 处理时间
      if (searchBoxData.DealDate && searchBoxData.DealDate.length > 0) {
        searchBoxData.startDealDate = this.formatDate(searchBoxData.DealDate[0]);
        searchBoxData.endDealDate = this.formatDate(searchBoxData.DealDate[1]);
        delete searchBoxData.DealDate;
      }
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'WARING_TYPE',
    });
    this.searchBoxData.waringTypeOptions = enumsList[0];
    this.searchBoxData.orgIdOptions = await getDepartmentAllList();
  },
};
</script>

<style lang="scss" scoped>
</style>
